import { Editor } from '@tiptap/react';
import { DOMSerializer } from '@tiptap/pm/model';

import {
  TEMPLATE_FIELD_INLINE_NAME,
  TEMPLATE_FIELD_BLOCK_NAME,
  TEMPLATE_FIELD_DROPDOWN_NAME,
} from '../doc-engine/templateFields';
import { stripTransientProvenanceHtml } from './cleanForSave.helper';
import { buildDropdownCommentValue } from '@shared/backendFrontend/dropdownCommentValue';
import type { TFieldSelection } from '@modules/comments';
import { SELECTION_MARK_NAME, SELECTION_NODE_NAME } from '@modules/comments/constants';

export const getCommentFieldSelection = (editor: Editor, commentId: string): TFieldSelection | null => {
  const { doc, schema } = editor.state;
  const serializer = DOMSerializer.fromSchema(schema);

  let result: TFieldSelection | null = null;
  doc.descendants((node) => {
    if (result) return false;

    if (node.type.name === TEMPLATE_FIELD_DROPDOWN_NAME) {
      const fieldId = node.attrs.fieldId;
      const marked = node.marks.some((m) => m.type.name === SELECTION_MARK_NAME && m.attrs.commentId === commentId);
      if (fieldId && marked) {
        result = { fieldId, fieldHtml: buildDropdownCommentValue(node.attrs.selectedValue || '', commentId) };
      }
      return false;
    }

    if (node.type.name !== TEMPLATE_FIELD_INLINE_NAME && node.type.name !== TEMPLATE_FIELD_BLOCK_NAME) return;

    const fieldId = node.attrs.fieldId;
    if (!fieldId) return false;

    let hasAnchor = false;
    node.descendants((child) => {
      if (child.type.name === SELECTION_NODE_NAME && child.attrs.commentId === commentId) hasAnchor = true;
      if (child.marks.some((m) => m.type.name === SELECTION_MARK_NAME && m.attrs.commentId === commentId))
        hasAnchor = true;
    });
    if (!hasAnchor) return false;

    const wrapper = document.createElement('div');
    wrapper.appendChild(serializer.serializeFragment(node.content));
    // Strip transient provenance (image data-doc-id, caption ZWSP) so the sent HTML matches the
    // field value as cleanForSave persisted it; the comment anchor is preserved.
    result = { fieldId, fieldHtml: stripTransientProvenanceHtml(wrapper.innerHTML) };
    return false;
  });

  return result;
};
